import React, { useEffect, useState } from "react";
import Axios from "axios";
import { NODE_HOST_URL } from "./api/Api";

const AgentChatReport = () => {
  const [chatData, setChatData] = useState({
    total_chat: [],
    answer_chat: [],
    missed_chat: [],
    new_chat: [],
    total_repeat: [],
    live_chat: []
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchWhatsappNumber();
  }, []);

  const fetchWhatsappNumber = async () => {
    setLoading(true);
    try {
      const lStorage = JSON.parse(localStorage.getItem("login"));
      const userId = lStorage.user.userId;
      const userToken = lStorage.token;

      const response = await Axios.post(
        "https://console.authkey.io/api/wp_profile.php",
        { user_id: userId, token: userToken, method: "retrieve" }
      );

      if (response.data.success === true && response.data.data?.length > 0) {
        const number = response.data.data[0].brand_number || "";
        fetchChatReport(userId, userToken, number);
      } else {
        setError("Brand number not found.");
        setLoading(false);
      }
    } catch {
      setError("Error fetching WhatsApp number.");
      setLoading(false);
    }
  };

  const fetchChatReport = async (userId, userToken, brandNo) => {
    try {
      const payload = {
        user_id: userId,
        token: userToken,
        method: "today_report",
        brand_number: brandNo,
        user_type: "admin",
        agent_id: userId
      };

      const response = await Axios.post(
        `${NODE_HOST_URL}/whatsapp_report`,
        payload
      );

      if (response.data.success) {
        setChatData(response.data.data);
      } else {
        setError(response.data.message || "Failed to load chat report.");
      }
    } catch {
      setError("Error fetching chat report.");
    } finally {
      setLoading(false);
    }
  };

  const total = chatData.total_chat?.length || 0;

  const stats = [
    { label: "Answered", value: chatData.answer_chat?.length || 0, color: "#20c997" },
    { label: "Unanswered", value: chatData.missed_chat?.length || 0, color: "#e76f51" },
    { label: "New", value: chatData.new_chat?.length || 0, color: "#343a40" },
    { label: "Repeated", value: chatData.total_repeat?.length || 0, color: "#f9c74f" },
    { label: "Live", value: chatData.live_chat?.length || 0, color: "#4dabf7" }
  ];

  return (
    <div
      style={{
        background: "#fff",
        borderRadius: "12px",
        padding: "8px 12px",          // reduced padding
        fontFamily: "Arial, sans-serif",
        boxShadow: "0 6px 15px rgba(0,0,0,0.1)",
        width: "100%",
        maxWidth: "320px",
        transition: "transform 0.2s, box-shadow 0.2s",
        cursor: "default",
        border: "1px solid #e0e0e0"
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-2px)";
        e.currentTarget.style.boxShadow = "0 10px 20px rgba(0,0,0,0.12)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "0 6px 15px rgba(0,0,0,0.1)";
      }}
    >
      <div style={{ marginBottom: "6px", borderBottom: "1px solid #f0f0f0", paddingBottom: "4px" }}>
        <h6 style={{
          margin: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between"
        }}>
          <strong>Today's Total Chats</strong>
          <strong style={{ color: "#000", fontSize: "0.95rem" }}>{total}</strong>
        </h6>
      </div>

      {loading && <div style={{ fontSize: "0.75rem", color: "#777" }}>Loading...</div>}
      {error && <div style={{ fontSize: "0.75rem", color: "red" }}>{error}</div>}

      {!loading && !error && (
        <div style={{ marginTop: "4px" }}>
          {stats.map((stat, idx) => {
            const percentage = total > 0 ? (stat.value / total) * 100 : 0;
            return (
              <div key={idx} style={{ marginBottom: "4px" }}>  {/* reduced margin */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: "0.75rem",
                    marginBottom: "1px"
                  }}
                >
                  <span style={{ color: "#555", fontWeight: "bold" }}>{stat.label}</span>
                  <span style={{ fontWeight: "600" }}>{stat.value}</span>
                </div>
                <div
                  style={{
                    height: "4px",   // thinner progress bar
                    borderRadius: "2px",
                    background: "#f1f3f5",
                    overflow: "hidden"
                  }}
                >
                  <div
                    style={{
                      width: `${percentage}%`,
                      background: stat.color,
                      height: "100%",
                      transition: "width 0.4s ease"
                    }}
                  ></div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default AgentChatReport;
